import type { SVGProps } from "react";

export const UploadCircleOutlinedIcon = ({
  width = "12",
  height = "12",
  ...props
}: {
  width?: string | number;
  height?: string | number;
} & SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M6 11C8.7614 11 11 8.7614 11 6C11 3.23857 8.7614 1 6 1C3.23857 1 1 3.23857 1 6C1 8.7614 3.23857 11 6 11Z"
      stroke="#8C6727"
    />
    <path
      d="M5.99155 8.5V5.51225M5.99155 5.51225C5.86085 5.5105 5.73185 5.602 5.6367 5.71365L4.99952 6.44135M5.99155 5.51225C6.11765 5.514 6.2454 5.605 6.34635 5.71365L6.98725 6.44135M7.4951 4H4.49512"
      stroke="#8C6727"
      strokeWidth="0.75"
      strokeLinecap="round"
    />
  </svg>
);
